import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { WsProvider } from "@/context/WsContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import JobDetail from "@/pages/JobDetail";
import Profile from "@/pages/Profile";
import CleanerProfile from "@/pages/CleanerProfile";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";

import PMDashboard from "@/pages/pm/PMDashboard";
import Properties from "@/pages/pm/Properties";
import JobsBoard from "@/pages/pm/JobsBoard";
import PMCalendar from "@/pages/pm/PMCalendar";
import PMPayments from "@/pages/pm/PMPayments";

import CleanerDashboard from "@/pages/cleaner/CleanerDashboard";
import Marketplace from "@/pages/cleaner/Marketplace";
import MyJobs from "@/pages/cleaner/MyJobs";
import CleanerCalendar from "@/pages/cleaner/CleanerCalendar";
import Earnings from "@/pages/cleaner/Earnings";
import Onboarding from "@/pages/cleaner/Onboarding";
import Availability from "@/pages/cleaner/Availability";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";

import AdminOverview from "@/pages/admin/AdminOverview";
import AdminRevenue from "@/pages/admin/AdminRevenue";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminJobs from "@/pages/admin/AdminJobs";
import AdminPayouts from "@/pages/admin/AdminPayouts";
import AdminDisputes from "@/pages/admin/AdminDisputes";
import AdminBgChecks from "@/pages/admin/AdminBgChecks";
import AdminLogs from "@/pages/admin/AdminLogs";

const shell = (roles, Component) => (
  <ProtectedRoute roles={roles}>
    <Layout><Component /></Layout>
  </ProtectedRoute>
);

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <WsProvider>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />

              <Route path="/pm" element={shell(["pm"], PMDashboard)} />
              <Route path="/pm/properties" element={shell(["pm"], Properties)} />
              <Route path="/pm/jobs" element={shell(["pm"], JobsBoard)} />
              <Route path="/pm/calendar" element={shell(["pm"], PMCalendar)} />
              <Route path="/pm/payments" element={shell(["pm"], PMPayments)} />
              <Route path="/pm/profile" element={shell(["pm"], Profile)} />

              <Route path="/cleaner" element={shell(["cleaner"], CleanerDashboard)} />
              <Route path="/cleaner/marketplace" element={shell(["cleaner"], Marketplace)} />
              <Route path="/cleaner/jobs" element={shell(["cleaner"], MyJobs)} />
              <Route path="/cleaner/calendar" element={shell(["cleaner"], CleanerCalendar)} />
              <Route path="/cleaner/availability" element={shell(["cleaner"], Availability)} />
              <Route path="/cleaner/earnings" element={shell(["cleaner"], Earnings)} />
              <Route path="/cleaner/onboarding" element={shell(["cleaner"], Onboarding)} />
              <Route path="/cleaner/profile" element={shell(["cleaner"], Profile)} />

              <Route path="/admin" element={shell(["admin"], AdminOverview)} />
              <Route path="/admin/revenue" element={shell(["admin"], AdminRevenue)} />
              <Route path="/admin/settings" element={shell(["admin"], AdminSettings)} />
              <Route path="/admin/users" element={shell(["admin"], AdminUsers)} />
              <Route path="/admin/jobs" element={shell(["admin"], AdminJobs)} />
              <Route path="/admin/payouts" element={shell(["admin"], AdminPayouts)} />
              <Route path="/admin/disputes" element={shell(["admin"], AdminDisputes)} />
              <Route path="/admin/background-checks" element={shell(["admin"], AdminBgChecks)} />
              <Route path="/admin/logs" element={shell(["admin"], AdminLogs)} />

              <Route path="/jobs/:id" element={shell(["pm", "cleaner", "admin"], JobDetail)} />
              <Route path="/profile/:id" element={shell(["pm", "cleaner", "admin"], CleanerProfile)} />
            </Routes>
          </WsProvider>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
